const hasText = (value) => typeof value === 'string' && value.trim().length > 0;

const hasValidLanguages = (languages) =>
  Array.isArray(languages) &&
  languages.some((item) => {
    if (typeof item === 'string') return hasText(item);
    return (
      hasText(item?.language) &&
      item.language !== 'Select' &&
      hasText(item?.level) &&
      item.level !== 'Select Level'
    );
  });

const hasValidPhone = (profile = {}) => {
  const dialDigits = String(profile.dialCode || '').replace(/\D/g, '');
  const phoneDigits = String(profile.phoneNumber || '').replace(/\D/g, '');
  const maxLocal = Math.max(1, 15 - dialDigits.length);

  return dialDigits.length > 0 && phoneDigits.length >= 6 && phoneDigits.length <= maxLocal;
};

const hasValidDateOfBirth = (profile = {}) => {
  if (hasText(profile.dateOfBirth)) return true;
  return Boolean(profile.date && profile.month && profile.year);
};

export const PROFILE_REMINDER_STORAGE_KEY = 'kykyHideSellerProfileReminder';

export const getMissingProfileFields = (profile = {}, mode = 'buyer') => {
  const missing = [];

  if (!hasText(profile.firstname)) missing.push('First name');
  if (!hasText(profile.lastname)) missing.push('Last name');
  if (!hasValidDateOfBirth(profile)) missing.push('Date of birth');
  if (!hasText(profile.country)) missing.push('Country');
  if (!hasText(profile.city)) missing.push('City');
  if (!hasValidLanguages(profile.languages)) missing.push('Languages');
  if (!hasValidPhone(profile)) missing.push('Phone number');

  return missing;
};

export const isProfileComplete = (profile = {}, mode = 'buyer') =>
  getMissingProfileFields(profile, mode).length === 0;
